<template>
  <el-col :span="15" :offset="ml(isEdit)" class="item-lines-footer-texts">
    <span class="text-title-bold" v-if="footer.amount && type!=7">Total Qty.</span>
    <span class="text-title-bold" v-else>Total Qty. Difference</span>

    <span class="text-number" v-if="footer.amount && type!=7">{{totalAmount}}</span>
    <span class="text-number" v-else>{{totalQtyDifference}}</span>

    <span class="text-title-bold" v-if="footer.price">Total Amount</span>
    <span class="text-number" v-if="footer.price">{{totalPrice}}</span>
    <span class="text-title" v-if="footer.tax">&nbsp;&nbsp;&nbsp;&nbsp;[&nbsp;&nbsp;</span>
    <span v-if="footer.tax">Total Tax {{taxLabel}}</span>
    <span v-if="footer.tax" class="text-small-number">{{totalTax}}</span>
    <span v-if="footer.tax">&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>
    <span v-if="footer.tax">SubTotal</span>
    <span v-if="footer.tax" class="text-small-number">{{subTotal}}</span>
    <span v-if="footer.tax">&nbsp;&nbsp;&nbsp;]</span>
  </el-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'EditDetailFooter',
  computed: {
    ...mapGetters({
      totalAmount: 'edit/totalAmount',
      totalQtyDifference: 'edit/totalQtyDifference',
      totalPrice: 'edit/totalPrice',
      totalTax: 'edit/totalTax',
      subTotal: 'edit/subTotal',
      ml: 'prefs/footerMl'
    }),
    ...mapState('config', {
      footer: 'footer'
    }),
    ...mapState('edit', {
      taxType: 'taxType',
      type: 'type'
    }),
    taxLabel () {
      if (this.taxType === 2 || this.taxType === 3) {
        return '(GST 10%)'
      } else {
        return '(No Tax)'
      }
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.item-lines-footer-texts {
  background-color: #e0e0e03f;
}
.text-title-bold {
  display: inline-block;
  height: 100%;
  margin-left: 55px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.text-title {
  margin-left: 40px;
}
.text-number {
  display: inline-block;
  width: 70px;
  margin-left: 8px;
  margin-right: 30px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  color: #cc3300;
}
.text-small-number {
  display: inline-block;
  margin-left: 8px;
  font-weight: bold;
  color: #cc8067;
}
</style>
